// extracted by mini-css-extract-plugin
export default {"flag":"CountryFlag_flag__MCYl-"};